import { shallowEqual, useSelector } from 'react-redux';
import { getClassicGamePrize } from '../selectors';

export const useGamePrize = () => ({
  prize: useSelector(getClassicGamePrize, shallowEqual),
});
